// extracted by mini-css-extract-plugin
export default {"BlogPost_image":"EiSZVnjZriqjSAlO7IgC","BlogPost_body":"bunHbW_RP8FFJEX6LJAF","BlogPostTease":"wy34F7AzDMHG9VC54u9z"};